import React, { useEffect, useState } from 'react'
import { CaretDown, CaretUp } from 'react-bootstrap-icons'
import { FaEdit, FaSave, FaTrash } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { CustomButton } from '../../components/CustomButton'
import { CustomSpinner } from '../../components/CustomSpinner'
import Navbar from '../../components/navbar/navbar'
import { useOrderTable } from '../../hooks/useOrderTable'
import apinode from '../../services/apinode'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

const Marcas = () => {
  const [marcas, setMarcas] = useState([])
  const [editingId, setEditingId] = useState(null)
  const [editingNome, setEditingNome] = useState('')
  const [editingLeadtime, setEditingLeadtime] = useState(0)
  const [novaMarca, setNovaMarca] = useState('')
  const [novaLeadtime, setNovaLeadtime] = useState('')
  const [showModal, setShowModal] = useState(false)

  const [isLoadingMarcas, setIsLoadingMarcas] = useState(true)
  const [isRequestSaveLoading, setIsRequestSaveLoading] = useState(false)

  const handleEdit = (id, nome, leadtime) => {
    setEditingId(id)
    setEditingNome(nome)
    setEditingLeadtime(leadtime)
  }

  const handleSalvarAlteracoes = async (marcas) => {
    try {
      setIsRequestSaveLoading(true)
      const response = await apinode.post(
        `/estoque/marca/${localStorage.idconta}`,
        marcas
      )
      toast.success(response.data.message)
      listarMarcas()
    } catch (error) {
      console.error('Erro ao salvar alterações:', error)
      toast.error('Erro ao salvar alterações')
    } finally {
      setIsRequestSaveLoading(false)
    }
  }

  const handleSave = () => {
    const updatedMarcas = sortedMarcas.map((marca) =>
      marca.ID_MARCA === editingId
        ? { ...marca, DESC_MARCA: editingNome, LEAD_TIME: editingLeadtime }
        : marca
    )
    setMarcas(updatedMarcas)
    setEditingId(null)
    setEditingNome('')
    setEditingLeadtime(0)
  }

  const handleCancelEdit = () => {
    setEditingId(null)
    setEditingNome('')
    setEditingLeadtime(0)
  }

  const handleNovaMarcaChange = (event) => {
    setNovaMarca(event.target.value)
  }

  const handleNovaLeadtimeChange = (event) => {
    setNovaLeadtime(event.target.value)
  }

  const handleAdicionarMarca = () => {
    const ultimoIdMarca = marcas.reduce(
      (maxId, marca) => Math.max(maxId, marca.ID_MARCA),
      0
    )

    const novaMarcaObj = {
      ID_MARCA: ultimoIdMarca + 1,
      DESC_MARCA: novaMarca,
      LEAD_TIME: parseInt(novaLeadtime) || 0,
    }

    setMarcas([...marcas, novaMarcaObj])
    setNovaMarca('')
    setNovaLeadtime('')
    setShowModal(false)
  }

  const handleDelete = (id) => {
    const updatedMarcas = marcas.filter((marca) => marca.ID_MARCA !== id)
    setMarcas(updatedMarcas)
  }

  async function listarMarcas() {
    try {
      setIsLoadingMarcas(true)
      const response = await apinode.get(
        `/estoque/marca/${localStorage.idconta}`
      )
      setMarcas(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as marcas!')
    } finally {
      setIsLoadingMarcas(false)
    }
  }

  const {
    sortedArray: sortedMarcas,
    check,
    handleOrganize,
  } = useOrderTable(marcas, 'DESC_MARCA', 'asc')

  useEffect(() => {
    listarMarcas()
  }, [])

  return (
    <>
      <Navbar />
      <div className="container mt-page">
        <div className="col">
          <h1>Cadastro de Marcas</h1>

          <div className="d-flex justify-content-between">
            <button
              className="btn btn-primary mb-3"
              onClick={() => setShowModal(true)}
            >
              <span className="me-2">Adicionar Marca</span>
              <FaEdit />
            </button>

            <CustomButton
              title="Salvar Alterações"
              onClick={() => handleSalvarAlteracoes(marcas)}
              isLoading={isRequestSaveLoading}
              isLoadingText="Salvando..."
              styles={{
                height: 36,
              }}
            >
              <FaSave />
            </CustomButton>
          </div>

          {showModal && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                display: 'block',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
              }}
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Nova Marca</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label htmlFor="novaMarca" className="form-label">
                        Nome da Marca
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="novaMarca"
                        value={novaMarca}
                        onChange={handleNovaMarcaChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="novaLeadtime" className="form-label">
                        Lead Time (dias)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="novaLeadtime"
                        value={novaLeadtime}
                        onChange={handleNovaLeadtimeChange}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Fechar
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleAdicionarMarca}
                    >
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="row">
          <div className="col">
            {isLoadingMarcas ? (
              <div className="d-flex justify-content-center">
                <CustomSpinner />
              </div>
            ) : (
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Listagem de Marcas</h5>
                  <table className="table">
                    <thead>
                      <tr>
                        <th onClick={() => handleOrganize('ID_MARCA')}>
                          <span>ID</span>
                          <CaretUp color={check('ID_MARCA', 'asc')} />
                          <CaretDown color={check('ID_MARCA', 'desc')} />
                        </th>

                        <th onClick={() => handleOrganize('DESC_MARCA')}>
                          <span>Nome</span>
                          <CaretUp color={check('DESC_MARCA', 'asc')} />
                          <CaretDown color={check('DESC_MARCA', 'desc')} />
                        </th>

                        <th onClick={() => handleOrganize('LEADTIME')}>
                          <span>Lead Time</span>
                          <CaretUp color={check('LEADTIME', 'asc')} />
                          <CaretDown color={check('LEADTIME', 'desc')} />
                        </th>

                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedMarcas.map((marca) => (
                        <tr key={marca.ID_MARCA}>
                          <td>{marca.ID_MARCA}</td>
                          <td>
                            {editingId === marca.ID_MARCA ? (
                              <input
                                type="text"
                                value={editingNome}
                                onChange={(e) =>
                                  setEditingNome(e.target.value)
                                }
                              />
                            ) : (
                              marca.DESC_MARCA
                            )}
                          </td>
                          <td>
                            {editingId === marca.ID_MARCA ? (
                              <input
                                type="number"
                                value={editingLeadtime}
                                onChange={(e) =>
                                  setEditingLeadtime(Number(e.target.value))
                                }
                              />
                            ) : (
                              marca.LEAD_TIME
                            )}
                          </td>
                          <td>
                            {editingId === marca.ID_MARCA ? (
                              <>
                                <button
                                  className="btn btn-success"
                                  onClick={handleSave}
                                >
                                  <FaSave />
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={handleCancelEdit}
                                >
                                  Cancelar
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn btn-primary"
                                  onClick={() =>
                                    handleEdit(
                                      marca.ID_MARCA,
                                      marca.DESC_MARCA,
                                      marca.LEAD_TIME
                                    )
                                  }
                                >
                                  <FaEdit />
                                </button>
                                <button
                                  className="btn btn-danger"
                                  onClick={() =>
                                    handleDelete(marca.ID_MARCA)
                                  }
                                >
                                  <FaTrash />
                                </button>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Marcas
